import { Pipe, PipeTransform } from '@angular/core'
import { isObservable, map, Observable, of } from 'rxjs'

@Pipe({
  name: 'label',
  standalone: true,
})
export class LabelPipe implements PipeTransform {
  public transform(
    value: string | Observable<string | null | undefined> | null | undefined
  ): Observable<string> {
    if (isObservable(value)) {
      return value.pipe(map((val) => val ?? ''))
    }

    return of(value ?? '')
  }
}
